import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IrisModal, IrisModalI } from '@iris/common/models/IrisModal';
import { IrisSiaFilePickerComponent } from './sia-file-picker/sia-file-picker.component';

@Injectable()
export class IrisSiaSandbox {
  private readonly dialog = inject(MatDialog);
  public showFilePicker(folderId: string, maxSelectedPhotos: number): IrisModalI {
    const dialogRef: MatDialogRef<IrisSiaFilePickerComponent> = this.dialog
      .open(IrisSiaFilePickerComponent, {
        data: { folderId, maxSelectedPhotos },
        panelClass: 'modal-fullscreen',
      });

    return IrisModal.fromDialogRef(dialogRef);
  }
}